import { Cookies } from "react-cookie";
var cookies =new Cookies();
export const PERMISSIONS = {
  VIEWMARKETING_VIEW_PERSON       :      'VIEWMARKETING_EDIT_PERSON',
  VIEWMARKETING_EDIT_PERSON       :      'VIEWMARKETING_EDIT_PERSON',
  VIEWSTATEMENT_VIEW_DEPARTMENT   :  'VIEWSTATEMENT_VIEW_DEPARTMENT',
};

// Example: get user permissions from cookies or API
export function getUserPermissions() {
  // This is just an example; replace with your logic
  //const user = JSON.parse(localStorage.getItem('user') || '{}');
  //return user.permissions || [];
  const userPermissions = cookies.get('v-person-permission') || '';
  return userPermissions.split(',') || [];
}